import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {
  getEntityType,
  getExternalLinks,
  isExternalLinksEnabled,
  isPurchaseAvail,
} from '../../../services/albumProvider/albumProvider';
import {BI_SCHEMA} from '../../../services/biLogger/biEvents';
import {useBiLogger} from '../../BiProvider/withBiLogger';
import {Subtitle} from '../../ui/Subtitle/Subtitle';
import {ExternalLinks} from '../ExternalLinks';
import styles from './ExtrernalLinksContainer.scss';

export function ExternalLinksContainer(props) {
  const {album, track} = props;
  const biLogger = useBiLogger();
  const {t} = useTranslation();
  const externalLinks = getExternalLinks(album, track);
  const purchaseAvail = isPurchaseAvail(album, track);
  const isSeparatorShown = purchaseAvail;
  const shouldRender = isExternalLinksEnabled(album, track) && Boolean(externalLinks.length);
  const externalLinksSubtitle = t(
    purchaseAvail ? 'mgw.externalLinksSubtitle.purchaseAvail' : 'mgw.externalLinksSubtitle.purchaseNotAvail',
  );
  const handleExternalLinkActionButtonClick = ({buttonName, musicPlatform}) => {
    biLogger.log(BI_SCHEMA.player.downloadPage.externalLink.clicked, {
      type: getEntityType(album, track),
      buttonName,
      musicPlatform,
    });
  };

  return shouldRender ? (
    <div className={styles.container} data-hook="external-links-container">
      {isSeparatorShown ? <div className={styles.contentSeparator} data-hook="separator" /> : null}
      <Subtitle className={styles.externalLinksSubtitle}>{externalLinksSubtitle}</Subtitle>
      <ExternalLinks links={externalLinks} onActionButtonClick={handleExternalLinkActionButtonClick} />
    </div>
  ) : null;
}

ExternalLinksContainer.propTypes = {
  album: PropTypes.object,
  track: PropTypes.object,
  biLogger: PropTypes.object,
  t: PropTypes.func,
};
